import Logo from "../../styles/img/header.png";

const Header = ({ tenantName, tenantImage }) => {
  return (
    <>
      <section className="w-full flex flex-col items-center justify-center mt-6">
        {tenantImage ? (
          <img src={tenantImage} alt="" className="w-[27%]" />
        ) : (
          <img src={Logo} alt="" className="w-[220px]" />
        )}
        <p className="text-base text-center font-semibold">
          {tenantName || "FraudFighter"}
        </p>
        <span className="text-secundary-grey text-xs opacity-80">v2.0</span>
      </section>
    </>
  );
};

export default Header;
